import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formModel: '=',
        update: '&',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'general.Add from question pool' | translate }}</h2>
        </div>
        <div class="modal-body">
            <forms-questions-filter
                state="'allQuestions'"
                list="vm.list"
                filter="vm.filter"
                default-query="vm.defaultQuery"
                question-ids="vm.questionIds"
                show-randomized-filter="true"
            />
            <pagination-tools list="vm.list" ng-if="!vm.filter.amountOfQuestions"></pagination-tools>
            <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
            <table class="data01" ng-if="vm.list.items.length && !vm.loading">
                <thead>
                <tr>
                    <th class="w1p nosort"><input ng-click="vm.selectAll()" type="checkbox"></th>
                    <th>{{ 'forms.Question' | translate }}</th>
                    <th>{{ 'questions.ID' | translate }}</th>
                    <th>{{ 'forms.Pool' | translate }}</th>
                    <th>{{ 'forms.Category' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="question in vm.list.items">
                    <td>
                        <input type="checkbox"
                            ng-click="$event.stopPropagation();vm.toggleQuestion(question.id)"
                            ng-checked="vm.hasQuestion(question.id)">
                    </td>
                    <td>{{ question.nameWithoutHtml }}</td>
                    <td>{{ question.externalId }}</td>
                    <td>{{ question.pool ? question.pool.name : '' }}</td>
                    <td>{{ question.category ? question.category.name : '' }}</td>
                </tr>
                </tbody>
            </table>
            <pagination list="vm.list" ng-if="!vm.filter.amountOfQuestions"></pagination>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="primary" ng-if="vm.list.items.length && !vm.loading">
                    <button class="btn main" type="button" ng-click="vm.addSelected()">{{ 'general.Add selected' | translate }}</button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, toastr, ListFactory, QuestionResource, FormResource) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.FormResource = FormResource;
        this.allSelected = false;

        this.defaultQuery = {
            expand: 'pool,category,author,questionI18ns,activeI18n',
            formIdToExcludeQuestions: this.formModel.id,
            formType: this.formModel.type,
            pageSize: 25
        };

        this.filter = lodash.assign({}, this.defaultQuery);
        this.list = ListFactory.createWithPagination(QuestionResource.query.bind(QuestionResource));

        this.list.fetch(this.filter);
    }

    $onInit () {
        this.questionIds = [];
        this.existingQuestionIds = this.lodash.map(this.formModel.formQuestions, question => question.questionId);
    }

    addSelected () {
        this.FormResource.assignQuestions({ questionIds: this.questionIds, formId: this.formModel.id }).$promise
            .then(() => {
                this.toastr.success(this.$translate.instant('forms.Questions are successfully assigned'));
                this.update();
            })
            .catch((error) => {
                this.error = this.lodash.get(error.data, '[0].message');
                this.toastr.error(this.error);
            });
    }

    selectAll () {
        this.allSelected = !this.allSelected;
        if (this.allSelected) {
            this.questionIds = this.list.items.map(question => question.id);
        }
        else {
            this.questionIds = [];
        }
    }

    hasQuestion (key) {
        return this.lodash.includes(this.questionIds, key);
    }

    toggleQuestion (key) {
        if (this.hasQuestion(key)) {
            this.lodash.pull(this.questionIds, key);
        }
        else {
            this.questionIds.push(key);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/add/fromPool/index.js